<template>
    <div>

        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">

                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-7">
                                <div>
                                    <img class="app-icon" src="/img/apps/dice/app_icon.png" alt="Ping App Icon">
                                    <h1 class="display-3 text-white">
                                        Dice – A Minimal Digital Dice
                                        <span class="text-white">Tap or Shake to roll the dice.</span>
                                    </h1>
                                </div>
                                <p class="lead text-white">
                                    Dice is a beautifully crafted digital dice. 
                                    The app delights through smooth gesture driven navigation, subtle haptic feedback and a truly minimal design.
                                </p>
                                <div class="btn-wrapper">
                                    <a href="https://frhlch.at/f/dice?app=1" target="_blank">
                                        <img width="150" src="/img/app/download_appstore.png" alt="Download Dice on the App Store">
                                    </a>
                                </div>
                            </div>
                            <div class="col-lg-5">
                                <app-showcase 
                                    imageSrc="/img/apps/dice/dice_video_placeholder.png" 
                                    videoSrc="https://www.dropbox.com/s/m0es8z9iokku89k/dice_showcase_scaled.mp4?dl=1" 
                                    posterSrc="/img/apps/dice/dice_video_placeholder.png"
                                    class="floating"
                                    >
                                </app-showcase>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>

    <div class="bottom-spacer"></div>

    </div>
</template>

<script>
export default {
  name: "Dice",
  components: {}
};
</script>

<style scoped lang="css">
    .no-pointer-events {
        pointer-events: none;
    }

    h1 {
        display: inline-grid;
    }

    h1 span {
        font-size: 1.5rem;
        color: rgba(0,0,0,0.7);
    }

    .app-icon {
        width: 70px;
        height: 70px;
        object-fit: contain;
        display: inline-grid;
        margin-right: 15px;
        margin-top: 10px;
    }

    .app-showcase {
        width: 350px;
        height: 700px;
        margin: auto;
        margin-top: 60px;
    }

    @media (min-width: 992px) {
        .app-showcase {
            position: absolute;
            top: -65px;
            right: 0;
        }
    }

    .section-shaped .shape-style-1.shape-default {
        /* background: linear-gradient(150deg, #ffffff 15%, #e0e0e0 70%, #afafaf 94%); */
        background: rgb(88, 204, 249);
    }

    .bottom-spacer {
        margin-bottom: 300px;
    }

</style>
